import React, {Component} from 'react';
import Form from './form';
import * as Inflector from 'inflected';

import request from '../request';

export default class PatientsChat extends Component {
  constructor(props) {
    super(props);
    let script = props.chat_script.data;
    this.state = {script};

    this.submit = this.submit.bind(this);
    this.addNode = this.addNode.bind(this);
    this.editNode = this.editNode.bind(this);
    this.deleteNode = this.deleteNode.bind(this);
    this.onChangeNode = this.onChangeNode.bind(this);
    this.onCancelNodeEdit = this.onCancelNodeEdit.bind(this);
    this.onSubmitNodesOrder = this.onSubmitNodesOrder.bind(this);
  }

  submit() {
    let {script} = this.state;
    let {chat_script} = this.props;

    let url = `/admin/chat_scripts/${chat_script.id}`
    request('PUT', url, {chat_script: {data: script}}).then(chat_script => {
      let {data} = chat_script;
      this.setState({script: data});
    });
  }


  onChangeNode(node) {
    let {script} = this.state;
    if (node.id) {
      let index = script.nodes.findIndex(n => n.id === node.id);
      script.nodes[index] = node;
    } else {
      node.id = generateUUID();
      script.nodes.push(node);

      // Add nodes to the visible nodes list
      script.nodes_order.push(node.id)
    }

    this.setState({script, current_node: undefined}, this.submit);
  }

  onCancelNodeEdit() {
    this.setState({current_node: undefined});
  }

  addNode() {
    this.setState({current_node: createNode()});
  }

  editNode(node_id) {
    let {script} = this.state;
    let index = script.nodes.findIndex(n => n.id === node_id);
    let current_node = script.nodes[index];
    this.setState({current_node});
  }

  deleteNode(node_id) {
    if (!confirm('Are you sure?')) return;

    let {script} = this.state;

    // Check if the node is in the nodes_order list
    let index = script.nodes_order.indexOf(node_id);
    if (index !== -1) {
      script.nodes_order.splice(index, 1);
    }

    // Remove the routes that use this node
    for (let node of script.nodes) {
      if (node.routes && node.routes.length > 0) {
        node.routes = node.routes.filter(r => r.next_node_id !== node_id)
      }
    }

    index = script.nodes.findIndex(n => n.id === node_id);
    script.nodes.splice(index, 1);
    this.setState({script}, this.submit);
  }

  editExtraModel(extra_model_id) {
    this.setState({show_extra_model_editor: true, extra_model_id});
  }

  editOrder() {
    this.setState({show_order_editor: true});
  }

  onSubmitNodesOrder(nodes_order) {
    let {script} = this.state;
    script.nodes_order = nodes_order;
    this.setState({script, show_order_editor: false}, this.submit);
  }

  onSubmitExtraModel(extra_model) {
    let {script, extra_model_id} = this.state;
    script.extra_models[extra_model_id] = extra_model
    this.setState({script, show_extra_model_editor: false, extra_model_id: undefined}, this.submit);
  }

  onCancelEditExtraModel() {
    this.setState({show_extra_model_editor: false, extra_model_id: undefined});
  }

  renderExtraModels() {
    let {script} = this.state;
    return (
      <div>
        <h2>Extra Model</h2>
        {Object.keys(script.extra_models).map(extra_model_id => {
          let extra_model = script.extra_models[extra_model_id];
          return (
            <div id="prompts" key={extra_model_id}>
              <h3>{extra_model_id} <button className="btn btn-default btn-sm" onClick={e => this.editExtraModel(extra_model_id)}>Edit</button></h3>
              <p>MODEL: {extra_model.model_name}</p>
              <pre>{extra_model.prompt}</pre>
            </div>
          )
        })}
      </div>
    )
  }

  renderExtraModelEditor() {
    let {script, extra_model_id} = this.state;
    let extra_model = script.extra_models[extra_model_id];
    return <ExtraModelEditor extra_model={extra_model} extra_model_id={extra_model_id} onSubmit={e => this.onSubmitExtraModel(e)} onCancel={e => this.onCancelEditExtraModel()} />
  }

  renderOrder() {
    let {script} = this.state;
    if (script.nodes_order.length === 0) return <p>NO NODES ADDED</p>
    let nodes = script.nodes_order.map(node_id => {
      let node = script.nodes.find(n => n.id === node_id)
      return node.name;
    })

    return (
      <div>
        <h2>Nodes Order</h2>
        <button className="btn btn-default btn-sm" onClick={e => this.editOrder()}>Change Order</button>

        <pre>{nodes.join(" -> ")}</pre>
      </div>
    )
  }

  renderViewer() {
    let {script} = this.state;
    return (
      <div>
        {this.renderExtraModels()}
        {this.renderOrder()}
        <ScriptViewer script={script} addNode={this.addNode} editNode={this.editNode} deleteNode={this.deleteNode} />
      </div>
    )
  }

  renderNodeEditor() {
    let {current_node, script} = this.state;
    return <NodeEditor node={current_node} script={script} onSubmit={this.onChangeNode} onCancel={this.onCancelNodeEdit} />
  }

  renderNodesOrderEditor() {
    let {script} = this.state;
    return <NodesOrder script={script} onSubmit={this.onSubmitNodesOrder} />
  }

  render() {
    let {current_node, show_order_editor, show_extra_model_editor} = this.state;
    if (current_node) {
      return this.renderNodeEditor();
    } else if (show_order_editor) {
      return this.renderNodesOrderEditor();
    } else if (show_extra_model_editor) {
      return this.renderExtraModelEditor();
    } else {
      return this.renderViewer();
    }
  }
}

class NodesOrder extends Component {
  constructor(props) {
    super(props);
    let {nodes_order} = this.props.script;
    this.state = {nodes_order};
    this.showAddNode = this.showAddNode.bind(this);
    this.onAddNewNode = this.onAddNewNode.bind(this);
    this.submit = this.submit.bind(this);
  }

  submit(e) {
    e.preventDefault();
    let {nodes_order} = this.state;
    let {onSubmit} = this.props;
    onSubmit(nodes_order);
  }

  onAddNewNode({node_id}) {
    let {nodes_order} = this.state;
    nodes_order.push(node_id);
    this.setState({nodes_order, show_add_node: false});
  }

  moveTop(node_id) {
    let {nodes_order} = this.state;
    let index = nodes_order.findIndex(id => id === node_id);
    nodes_order.splice(index, 1);
    nodes_order.unshift(node_id);
    this.setState({nodes_order});
  }

  moveBottom(node_id) {
    let {nodes_order} = this.state;
    let index = nodes_order.findIndex(id => id === node_id);
    nodes_order.splice(index, 1);
    nodes_order.push(node_id);
    this.setState({nodes_order});
  }

  moveUp(node_id) {
    let {nodes_order} = this.state;
    let index = nodes_order.findIndex(id => id === node_id);
    nodes_order.splice(index, 1);
    nodes_order.splice(index - 1, 0, node_id);
    this.setState({nodes_order});
  }

  moveDown(node_id) {
    let {nodes_order} = this.state;
    let index = nodes_order.findIndex(id => id === node_id);
    nodes_order.splice(index, 1);
    nodes_order.splice(index + 1, 0, node_id);
    this.setState({nodes_order});
  }

  delete(node_id) {
    let {nodes_order} = this.state;
    let index = nodes_order.findIndex(id => id === node_id);
    nodes_order.splice(index, 1);
    this.setState({nodes_order});
  }


  showAddNode() {
    this.setState({show_add_node: true});
  }

  renderNode(node_id) {
    let {script} = this.props;
    let node = script.nodes.find(n => n.id === node_id);

    return (
      <div key={node.id}>
        <Node node={node} />
        <button className="btn btn-default btn-sm" onClick={e => this.moveTop(node.id)}><span className="fa-solid fa-arrows-up-to-line"></span></button>
        <button className="btn btn-default btn-sm" onClick={e => this.moveUp(node.id)}><span className="fa-solid fa-arrow-up"></span></button>
        <button className="btn btn-default btn-sm" onClick={e => this.moveDown(node.id)}><span className="fa-solid fa-arrow-down"></span></button>
        <button className="btn btn-default btn-sm" onClick={e => this.moveBottom(node.id)}><span className="fa-solid fa-arrows-down-to-line"></span></button>
        <button className="btn btn-default btn-sm" onClick={e => this.delete(node.id)}><span className="fa-solid fa-trash"></span></button>
      </div>
    );
  }


  renderAddNodeForm() {
    let {script} = this.props;
    return <AddNodeToNodesOrder script={script} onSubmit={this.onAddNewNode} onCancel={e => this.setState({show_add_node: false})} />
  }

  render() {
    let {show_add_node, nodes_order} = this.state;
    if (show_add_node) return this.renderAddNodeForm();

    return (
      <div>
        <h2>Nodes Order</h2>
        <button className="btn btn-success" onClick={this.submit}>Save Changes</button>
        <button className="btn btn-default" onClick={this.showAddNode}>Add Node</button>
        {nodes_order.map(node_id => this.renderNode(node_id))}
      </div>
    )
  }
}


class AddNodeToNodesOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {new_node: {}};
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    let {onSubmit} = this.props;
    let {new_node} = this.state;
    onSubmit(new_node);
  }

  onChange(new_node) {
    this.setState({new_node});
  }


  render() {
    let {script, onCancel} = this.props;
    let {new_node} = this.state;
    let fields = [
      {name: 'node_id', type: 'select', collection: script.nodes}
    ]

    return <Form model={new_node} modelName="Node" fields={fields} onChange={this.onChange} onSubmit={this.onSubmit} onCancel={onCancel} />
  }
}

class ScriptViewer extends Component {
  renderNodes() {
    let {script, addNode, editNode, deleteNode} = this.props;
    return (
      <div>
        <h2>Nodes</h2>
        <button className="btn btn-default" onClick={e => addNode()}>Add Node</button>
      {script.nodes.map(node => {
        return (
          <div key={node.id}>
            <Node node={node} />
            <button className="btn btn-default btn-sm" onClick={e => editNode(node.id)}>Edit</button>
            <button className="btn btn-danger btn-sm" onClick={e => deleteNode(node.id)}>Delete</button>
          </div>
        )
      })}
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.renderNodes()}
      </div>
    )

  }
}

class Node extends Component {
  render() {
    let {node} = this.props;
    let node_type = node.type === CUSTOM_TYPE_ID ? node.custom_type : node.type;
    return (
      <div>
        <h3>{node.name} [{node_type}]</h3>
        <p>{node.prompt}</p>
      </div>
    )

  }
}

class NodeEditor extends Component {
  constructor(props) {
    super(props);
    let node = Object.assign({}, props.node);
    this.state = {node};
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }


  onSubmit(e) {
    e.preventDefault();
    let {node} = this.state;
    let {onSubmit} = this.props;
    onSubmit(node);
  }

  onChange(node) {
    this.setState({node});
  }

  fields() {
    let {script} = this.props;

    return [
      {name: 'name', required: true},
      {name: 'type', type: 'select', collection: NODE_TYPES, required: true},
      {name: 'custom_type', required: true, visible: n => n.type === 'custom'},
      {name: 'prompt', type: 'text', rows: 4, required: true},
      {name: 'source', visible: n => n.type == 'select_input'},
      {name: 'search_field', visible: n => n.type == 'select_input'},
      {name: 'instructions', type: 'text', rows:20, autosize: true, required: true, visible: n => n.type === 'openai'},
      {name: 'collection', type: CollectionEditor, visible: n => n.type === 'select_input' || n.type === 'buttons_group' || n.type === 'checkboxes_input'},
      {name: 'accent', type: 'select', collection: ACCENT_OPTIONS, visible: n => n.type === 'boolean_buttons'},
      {name: 'visible'},
      {name: 'loading_text'},
      {name: 'routes', type: RoutesEditor, script: script, visible: n => ROUTABLE_NODE_TYPES.indexOf(n.type) !== -1},

      {name: 'api_callback', type: 'bool'},
      {name: 'api_callback_instructions', type: apiCallbackInstructions, visible: v => v.api_callback},
      {name: 'api_callback_url', hint: 'Use the special placeholder "{{$NODE_VALUE}}" to send the current node value', required: true, visible: v => v.api_callback},
      {name: 'api_callback_method', type: 'select', collection: ['GET', 'POST', 'PUT'], required: true, visible: v => v.api_callback},
      {name: 'api_callback_basic_auth', type: 'bool', visible: v => v.api_callback},
      {name: 'api_callback_auth_client_id', visible: v => v.api_callback_basic_auth},
      {name: 'api_callback_auth_client_secret', visible: v => v.api_callback_basic_auth},

      // Openai nodes
      {name: 'advanced', type: 'bool', visible: n => n.type === 'openai'},
      {name: 'model_name', type: 'slektr', src: "/admin/chat_scripts/openai_models", search_key: 'name', visible: n => n.type === 'openai' && n.advanced},
      {name: 'temperature', type: 'float', hint: 'What sampling temperature to use, between 0 and 2.', visible: n => n.type === 'openai' && n.advanced},
      {name: 'top_p', type: 'float', hint: 'minimum: 0 maximum: 1', visible: n => n.type === 'openai' && n.advanced},
      {name: 'reasoning_effort', type: 'select', collection: OPENAI_REASONING_EFFORT_OPTIONS, visible: n => n.type === 'openai' && n.advanced}
    ]
  }

  render() {
    let {node} = this.state;
    let {onCancel} = this.props;

    return (
      <div>
        <h1>Node Editor</h1>
        <Form fields={this.fields()} model={node} modelName="Node" onChange={this.onChange} onSubmit={this.onSubmit} onCancel={onCancel} />
      </div>
    )
  }
}

function apiCallbackInstructions() {
  return (
    <div>
      <h4>API Callback</h4>
      The server will make a request to the given URL and will append the response to the user data
    </div>
  );
}


class RoutesEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  onSubmit() {
    let {field, value, onChange} = this.props;
    let {current_route} = this.state;
    if (!value) value = [];

    if (current_route.id) {
      let index = value.find(r => r.id === current_route.id);
      value[index] = current_route;
    } else {
      current_route.id = generateUUID();
      value.push(current_route);
    }
    onChange({target: {name: field.name, value}});
    this.setState({show_form: false, current_route: undefined});
  }

  onChange(current_route) {
    this.setState({current_route});
  }

  onCancel() {
    this.setState({show_form: false, current_route: undefined});
  }

  newRoute() {
    let current_route = {};
    this.setState({show_form: true, current_route});
  }

  editRoute(route) {
    this.setState({show_form: true, current_route: route});
  }

  deleteRoute(route) {
    let {field, value, onChange} = this.props;
    let index = value.findIndex(r => r.id === route.id);
    value.splice(index, 1);
    onChange({target: {name: field.name, value}});
  }


  moveRouteUp(route) {
    let {field, value, onChange} = this.props;
    let index = value.findIndex(r => r.id === route.id);
    value.splice(index, 1);
    value.splice(index - 1, 0, route);
    onChange({target: {name: field.name, value}});
  }

  moveRouteDown(route) {
    let {field, value, onChange} = this.props;
    let index = value.findIndex(r => r.id === route.id);
    value.splice(index, 1);
    value.splice(index + 1, 0, route);
    onChange({target: {name: field.name, value}});
  }

  renderForm() {
    let {script} = this.props.field;
    let {current_route} = this.state;

    let fields = [
      {name: 'next_node_id', type: 'select', collection: script.nodes, required: true},
      {name: 'validation', required: true}
    ]

    let title = current_route.id ? 'Edit Route' : 'New Route';
    return(
      <div>
        <h4>{title}</h4>
        <Form fields={fields} containerElement="div" model_name="route" model={current_route} onChange={this.onChange} onSubmit={this.onSubmit} onCancel={this.onCancel} />
      </div>
    )
  }


  renderRoutes() {
    let {value, field} = this.props;
    if (!value || value.length === 0) return null;

    let {script} = field;
    return (
      <div>
        {value.map(route => {
          let node = script.nodes.find(n => n.id === route.next_node_id);
          return (
            <div key={node.id}>
              <p>{node.name}</p>
              <i>{route.validation}</i>
              <button className="btn btn-default btn-sm" onClick={e => this.editRoute(route)}>Edit</button>
              <button className="btn btn-danger btn-sm" onClick={e => this.deleteRoute(route)}>Delete</button>
              <button className="btn btn-default btn-sm" onClick={e => this.moveRouteUp(route)}>Up</button>
              <button className="btn btn-default btn-sm" onClick={e => this.moveRouteDown(route)}>Down</button>

            </div>
          )
        })}
      </div>
    )
  }

  renderContent() {
    let {value} = this.props;
    let {show_form} = this.state;
    if (show_form) {
      return this.renderForm();
    }
    return this.renderRoutes();
  }

  render() {
    let {field} = this.props;
    let label = field.label || Inflector.titleize(field.name);
    return (
      <div id="custom_routes">
        <hr />
        <h3>Custom Routes</h3>
        <button className="btn btn-sm" onClick={e => this.newRoute()}>Add Custom Route</button>
        {this.renderContent()}
      </div>
    )
  }
}


class CollectionEditor extends Component {
  constructor(props) {
    super(props);
    let collection = props.value ? props.value.slice() : [];
    this.state = {collection, };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);

  }


  onSubmit(e) {
    e.preventDefault();
    let {field, value, onChange} = this.props;
    if (!value) value = [];

    let {current_item, current_index} = this.state;

    if (current_index) {
      value[current_index] = current_item;
    } else {
      value.push(current_item);
    }
    onChange({target: {name: field.name, value}});
    this.setState({current_item: undefined, current_index: undefined, show_form: false});
  }


  deleteItem(index) {
    let {field, value, onChange} = this.props;
    value.splice(index, 1);
    onChange({target: {name: field.name, value}});
  }


  moveItemUp(index) {
    let {field, value, onChange} = this.props;
    let item = value[index];
    value.splice(index, 1);
    value.splice(index - 1, 0, item);
    onChange({target: {name: field.name, value}});
  }

  moveItemDown(index) {
    let {field, value, onChange} = this.props;
    let item = value[index];
    value.splice(index, 1);
    value.splice(index + 1, 0, item);
    onChange({target: {name: field.name, value}});
  }

  toggleAccent(index) {
    let {field, value, onChange} = this.props;
    let item = value[index];
    item.accent = !item.accent;
    onChange({target: {name: field.name, value}});
  }

  onChange(current_item) {
    this.setState({current_item});
  }

  onCancel() {
    this.setState({current_item: undefined, current_index: undefined, show_form: false});
  }

  showForm() {
    let current_item = {id: '', name: ''};
    this.setState({current_item, show_form: true});
  }


  renderForm() {
    let {current_item} = this.state;
    let fields = [
      {name: 'id', required: true},
      {name: 'name', required: true}
    ]

    return <Form model={current_item} submitLabel="Save Item" fields={fields} onChange={this.onChange} onSubmit={this.onSubmit} onCancel={this.onCancel} containerElement="div" />
  }

  renderEmptyCollection() {
    return (
      <div>
        <strong>Empty Collection</strong>
        <button className="btn btn-default btn-sm" onClick={e => this.showForm()}>Add items</button>
      </div>
    )
  }

  renderContent() {
    let {show_form} = this.state;
    let {value} = this.props;
    if (show_form) return this.renderForm();
    if (!value || value.length === 0) return this.renderEmptyCollection();
    return (
      <div>
        {value.map((item, index) => {
          let accentClassName = item.accent ? 'btn btn-primary' : 'btn btn-default';
          return (
            <div key={item.id}>
              <strong>{item.id}</strong>: {item.name}
              <div className="btn-group">
                <button className="btn btn-default" onClick={e => this.setState({show_form: true, current_item: item, current_index: index})}><span className="fa fa-pencil-alt" /></button>
                <button className="btn btn-danger" onClick={e => this.deleteItem(index)}><span className="fa fa-trash" /></button>
                <button className="btn btn-default" onClick={e => this.moveItemUp(index)}><span className="fa-solid fa-arrow-up" /></button>
                <button className="btn btn-default" onClick={e => this.moveItemDown(index)}><span className="fa-solid fa-arrow-down" /></button>
                <button className={accentClassName} onClick={e => this.toggleAccent(index)}><span className="fa-solid fa-star" /></button>
              </div>
            </div>
          )
        })}
        <button className="btn btn-default btn-sm" onClick={e => this.showForm()}>Add items</button>
      </div>
    )

  }
  render() {
    let {field} = this.props;
    let label = field.label || Inflector.titleize(field.name);
    return (
      <div>
        <label>{label}</label>
        {this.renderContent()}
      </div>
    )
  }
}


class ExtraModelEditor extends Component {
  constructor(props) {
    super(props);
    let {extra_model} = this.props;
    this.state = {extra_model};
  }

  submit(e) {
    e.preventDefault();
    let {extra_model} = this.state
    this.props.onSubmit(extra_model);
  }

  onChange(extra_model) {
    this.setState({extra_model});
  }

  render() {
    let {extra_model_id, onCancel} = this.props;
    let {extra_model} = this.state
    let fields = [
      {name: 'prompt', type: 'text'},
      {name: 'main_model_prompt', type: 'text', visible: () => extra_model_id === 'file_analysis'},
      {name: 'model_name', type: 'slektr', src: "/admin/chat_scripts/openai_models", search_key: 'name'},
      {name: 'temperature', type: 'float', hint: 'What sampling temperature to use, between 0 and 2.'},
      {name: 'top_p', type: 'float', hint: 'minimum: 0 maximum: 1'},
      {name: 'reasoning_effort', type: 'select', collection: OPENAI_REASONING_EFFORT_OPTIONS}
    ]

    return <Form submitLabel="Update Extra Model" model={extra_model} fields={fields} onChange={e => this.onChange(e)} onSubmit={e => this.submit(e)} onCancel={onCancel} />
  }
}

const CUSTOM_TYPE_ID = 'custom';
const NODE_TYPES = ['output', 'text_input', 'email_input', 'select_input', 'buttons_group', 'boolean_buttons', 'checkboxes_input', 'geolocation', 'openai', CUSTOM_TYPE_ID];
const ACCENT_OPTIONS = ['yes', 'no'];
const ROUTABLE_NODE_TYPES = ['select_input', 'buttons_group', 'boolean_buttons']
const OPENAI_REASONING_EFFORT_OPTIONS = ['none', 'minimal', 'low', 'medium', 'high', 'xhigh']
function createNode() {
  return {id: null, type: '', prompt: '', routes: []}
}
